import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "../../components/LegalLayout";
import LegalContentRenderer from "../../components/LegalContentRenderer";
import { LEGAL_CONTENT_2 } from "../../data/legalContent2";
import { LAST_UPDATED } from "../../data/legalContent";

export default function TermsOfUse() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "fr").slice(0, 2);
  const data = LEGAL_CONTENT_2.termsOfUse[lang] || LEGAL_CONTENT_2.termsOfUse.fr;
  const lastUpdated = LAST_UPDATED[lang] || LAST_UPDATED.fr;
  return (
    <LegalLayout title={data.title} lastUpdated={lastUpdated}>
      <LegalContentRenderer sections={data.sections} />
    </LegalLayout>
  );
}
